/**
 * Chat images live in Lit components that have no access to the workspace
 * services. They ask for the fullscreen viewer with this DOM event; the peek
 * view owner listens once per workspace and opens the image list.
 */
export const CHAT_IMAGE_OPEN_EVENT = 'streamlain:chat-image-open';

export interface ChatImageOpenDetail {
  images: string[];
  index: number;
}

export function dispatchChatImageOpen(
  source: EventTarget,
  detail: ChatImageOpenDetail
) {
  source.dispatchEvent(
    new CustomEvent<ChatImageOpenDetail>(CHAT_IMAGE_OPEN_EVENT, {
      bubbles: true,
      composed: true,
      detail,
    })
  );
}

export function readChatImageOpen(event: Event): ChatImageOpenDetail | null {
  if (!(event instanceof CustomEvent)) return null;
  const detail = event.detail as Partial<ChatImageOpenDetail> | null;
  if (
    !detail ||
    !Array.isArray(detail.images) ||
    typeof detail.index !== 'number' ||
    !detail.images[detail.index]
  ) {
    return null;
  }
  return { images: detail.images, index: detail.index };
}
